module.exports = (
    {
        "polyline": "Lộ trình",
        "icon": "Đánh dấu",
        "polygon": "Tạo hình",
        "DocumentTitle.map_page": "{branch_name} | Bản đồ",
        "DocumentTitle.error_page": "{branch_name} | Lỗi",
        "DocumentTitle.end_page": "{branch_name} | Hoàn thành",
        "DocumentTitle.intro_modal": "{branch_name} | Giới thiệu",
        "DocumentTitle.info_modal": "{branch_name} | Thông tin",
        "DocumentTitle.survey_modal": "{branch_name} | Khảo sát",
        "Landing.header": "Xin chào!",
        "Landing.main_copy": "Mời bạn sử dụng công cụ này để chia sẻ với chúng tôi những điều thú vị về nơi bạn sinh sống, giúp chúng tôi hiểu hơn về những điểm cần lưu ý.",
        "Landing.back_to_map": "Quay lại bản đồ",
        "Landing.start_answering": "Bắt đầu",
        "Landing.data.header": "Sử dụng dữ liệu",
        "Landing.data.copy": "Chúng tôi bảo vệ quyền riêng tư cá nhân, tất cả dữ liệu sẽ chỉ được sử dụng nội bộ.",
        "Landing.help.header": "Hướng dẫn",
        "Landing.help.copy": "Trên bản đồ, bạn có thể vẽ thêm các điểm, đường thẳng hoặc khoanh vùng các địa điểm. Bạn có thể tìm kiếm một địa điểm, xoay, phóng to hoặc thu nhỏ bản đồ, và có thể chuyển chế độ bản đồ đường bộ hoặc vệ tinh.",
        "Landing.feedback": "Gửi phản hồi cho chúng tôi",
        "MapContainer.continue": "Tiếp tục",
        "MapContainer.back_button": "Quay lại bản đồ",
        "MapContainer.info_button": "Hướng dẫn",
        "MapContainer.finish_button": "Đã xong với bản đồ",
        "MapContainer.submit": "Gửi đi",
        "MapContainer.mapButtonInfo": "Phóng to tới Vị trí",
        "MapContainer.roadmap": "Đường bộ",
        "MapContainer.satellite": "Vệ tinh",
        "CancelButton.text": "Hủy bỏ",
        "IconDrawer.expand_drawer": "Mở rộng",
        "IconDrawer.instructions": "Vẽ",
        "LayerToggle.roadmap": "Đường bộ",
        "LayerToggle.satellite": "Vệ tinh",
        "ConfirmationPopup.done": "Xong",
        "ConfirmationPopup.cancel": "Hủy bỏ",
        "PolygonDraw.default_message": "Nhấp vào bất kỳ đâu để bắt đầu vẽ hình.",
        "PolygonDraw.alternative_message": "Vẽ các điểm để thay đổi kích thước hình.",
        "PolylineDraw.default_message": "Nhấp vào bất kỳ đâu để bắt đầu vẽ đường thẳng.",
        "PolylineDraw.alternative_message": "Vẽ các điểm để thay đổi đường thẳng.",
        "IconDrop.default_message": "Nhấp vào bất kỳ đâu để thêm một biểu tượng.",
        "IconDrop.alternative_message": "Kéo biểu tượng để thay đổi vị trí.",
        "EditModal.delete": "Xóa",
        "EditModal.save": "Lưu",
        "EditModal.cancel": "Hủy bỏ",
        "EditModal.textarea_placeholder": "Trả lời thêm hoặc bấm lưu",
        "EditModal.addTitle": "Thêm {icon_type} của bạn",
        "EditModal.editTitle": "Sửa {icon_type} của bạn",
        "EditModal.reactionTitle": "Hãy nhận xét về trải nghiệm của bạn.",
        "EditModal.starRatingTitle": "Bạn đánh giá trải nghiệm này như thế nào?",
        "EditModal.commentTitle": "Bạn có ý kiến nào khác không?",
        "EditModal.deleteConfirmation": "Bạn có chắc chắn không?",
        "EditModal.deleteConfirmationText": "Không thể hoàn tác việc xóa {icon_type} này.",
        "SearchBox.placeholder": "Tìm kiếm vị trí",
        "Survey.submitting": "Đang gửi đi...",
        "EndLanding.header": "Xin cảm ơn",
        "EndLanding.copy": "Kết thúc",
        "EndLanding.take_again": "Chia sẻ thêm về khu vực của bạn - bắt đầu lại!"
    }
);



// WEBPACK FOOTER //
// ./src/locales/vi-VI.js